"use strict";

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _css2 = _interopRequireDefault(require("@emotion/css"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _ellipsis = _interopRequireDefault(require("polished/lib/mixins/ellipsis"));

var _useTheme2 = _interopRequireDefault(require("../styles/useTheme"));

var _Outlined = _interopRequireDefault(require("./Outlined"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var useStyles = function useStyles() {
  var _useTheme = (0, _useTheme2["default"])(),
      colors = _useTheme.colors,
      spacing = _useTheme.spacing,
      fonts = _useTheme.fonts;

  return (0, _react.useMemo)(function () {
    return {
      root: {
        border: 'none',
        borderRadius: 0,
        borderBottom: "1px solid ".concat(colors.inactive),
        padding: 0,
        minHeight: spacing(4),
        backgroundColor: colors.transparent,
        ':hover': {
          boxShadow: 'unset',
          border: 'none',
          borderRadius: 0,
          borderBottom: "1px solid ".concat(colors.primary)
        },
        ':focus-within': {
          boxShadow: 'unset',
          border: 'none',
          borderRadius: 0,
          borderBottom: "1px solid ".concat(colors.primary)
        },
        '& input': _objectSpread({}, fonts.headline3, {
          lineHeight: 1,
          color: colors.bayOfMary
        }, (0, _ellipsis["default"])('100%'), {
          '::placeholder': _objectSpread({}, fonts.messageMedium, {
            fontWeight: 900,
            lineHeight: 1,
            color: colors.inactive
          })
        })
      },
      error: {
        border: 'unset',
        borderBottom: "1px solid ".concat(colors.alert)
      }
    };
  }, [colors, spacing, fonts]);
};

__signature__(useStyles, "useTheme{{ colors, spacing, fonts }}\nuseMemo{}", function () {
  return [_useTheme2["default"]];
});

function Standard(props, ref) {
  var error = props.error,
      other = (0, _objectWithoutProperties2["default"])(props, ["error"]);
  var classes = useStyles();
  return (0, _core.jsx)(_Outlined["default"], (0, _extends2["default"])({
    css: /*#__PURE__*/(0, _css2["default"])([classes.root, error && classes.error], ";label:Standard;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9JbnB1dC9TdGFuZGFyZC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBNERtQiIsImZpbGUiOiIuLi8uLi9zcmMvSW5wdXQvU3RhbmRhcmQudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IGZvcndhcmRSZWYsIFJlZiwgdXNlTWVtbyB9IGZyb20gJ3JlYWN0JztcblxuaW1wb3J0IHsgQ1NTT2JqZWN0IH0gZnJvbSAnQGVtb3Rpb24vY29yZSc7XG5pbXBvcnQgZWxsaXBzaXMgZnJvbSAncG9saXNoZWQvbGliL21peGlucy9lbGxpcHNpcyc7XG5cbmltcG9ydCB1c2VUaGVtZSBmcm9tICcuLi9zdHlsZXMvdXNlVGhlbWUnO1xuaW1wb3J0IHsgR2VuZXJpY0NvbXBvbmVudCB9IGZyb20gJy4uL3R5cGVzL3dpdGgtYXMtcHJvcCc7XG5pbXBvcnQgT3V0bGluZWQsIHsgT3V0bGluZWRQcm9wcyB9IGZyb20gJy4vT3V0bGluZWQnO1xuXG5leHBvcnQgdHlwZSBTdGFuZGFyZFByb3BzPFQgZXh0ZW5kcyBHZW5lcmljQ29tcG9uZW50PiA9IE91dGxpbmVkUHJvcHM8VD47XG5cbmNvbnN0IHVzZVN0eWxlcyA9ICgpID0+IHtcbiAgY29uc3QgeyBjb2xvcnMsIHNwYWNpbmcsIGZvbnRzIH0gPSB1c2VUaGVtZSgpO1xuICByZXR1cm4gdXNlTWVtbzxDU1NPYmplY3Q+KFxuICAgICgpID0+ICh7XG4gICAgICByb290OiB7XG4gICAgICAgIGJvcmRlcjogJ25vbmUnLFxuICAgICAgICBib3JkZXJSYWRpdXM6IDAsXG4gICAgICAgIGJvcmRlckJvdHRvbTogYDFweCBzb2xpZCAke2NvbG9ycy5pbmFjdGl2ZX1gLFxuICAgICAgICBwYWRkaW5nOiAwLFxuICAgICAgICBtaW5IZWlnaHQ6IHNwYWNpbmcoNCksXG4gICAgICAgIGJhY2tncm91bmRDb2xvcjogY29sb3JzLnRyYW5zcGFyZW50LFxuICAgICAgICAnOmhvdmVyJzoge1xuICAgICAgICAgIGJveFNoYWRvdzogJ3Vuc2V0JyxcbiAgICAgICAgICBib3JkZXI6ICdub25lJyxcbiAgICAgICAgICBib3JkZXJSYWRpdXM6IDAsXG4gICAgICAgICAgYm9yZGVyQm90dG9tOiBgMXB4IHNvbGlkICR7Y29sb3JzLnByaW1hcnl9YCxcbiAgICAgICAgfSxcbiAgICAgICAgJzpmb2N1cy13aXRoaW4nOiB7XG4gICAgICAgICAgYm94U2hhZG93OiAndW5zZXQnLFxuICAgICAgICAgIGJvcmRlcjogJ25vbmUnLFxuICAgICAgICAgIGJvcmRlclJhZGl1czogMCxcbiAgICAgICAgICBib3JkZXJCb3R0b206IGAxcHggc29saWQgJHtjb2xvcnMucHJpbWFyeX1gLFxuICAgICAgICB9LFxuICAgICAgICAnJiBpbnB1dCc6IHtcbiAgICAgICAgICAuLi5mb250cy5oZWFkbGluZTMsXG4gICAgICAgICAgbGluZUhlaWdodDogMSxcbiAgICAgICAgICBjb2xvcjogY29sb3JzLmJheU9mTWFyeSxcbiAgICAgICAgICAuLi5lbGxpcHNpcygnMTAwJScpLFxuICAgICAgICAgICc6OnBsYWNlaG9sZGVyJzoge1xuICAgICAgICAgICAgLi4uZm9udHMubWVzc2FnZU1lZGl1bSxcbiAgICAgICAgICAgIGZvbnRXZWlnaHQ6IDkwMCxcbiAgICAgICAgICAgIGxpbmVIZWlnaHQ6IDEsXG4gICAgICAgICAgICBjb2xvcjogY29sb3JzLmluYWN0aXZlLFxuICAgICAgICAgIH0sXG4gICAgICAgIH0sXG4gICAgICB9LFxuICAgICAgZXJyb3I6IHtcbiAgICAgICAgYm9yZGVyOiAndW5zZXQnLFxuICAgICAgICBib3JkZXJCb3R0b206IGAxcHggc29saWQgJHtjb2xvcnMuYWxlcnR9YCxcbiAgICAgIH0sXG4gICAgfSksXG4gICAgW2NvbG9ycywgc3BhY2luZywgZm9udHNdXG4gICk7XG59O1xuXG5mdW5jdGlvbiBTdGFuZGFyZDxUIGV4dGVuZHMgR2VuZXJpY0NvbXBvbmVudCA9ICdpbnB1dCc+KHByb3BzOiBTdGFuZGFyZFByb3BzPFQ+LCByZWY/OiBSZWY8VD4pIHtcbiAgY29uc3QgeyBlcnJvciwgLi4ub3RoZXIgfSA9IHByb3BzO1xuICBjb25zdCBjbGFzc2VzID0gdXNlU3R5bGVzKCk7XG5cbiAgcmV0dXJuIDxPdXRsaW5lZCBjc3M9e1tjbGFzc2VzLnJvb3QsIGVycm9yICYmIGNsYXNzZXMuZXJyb3JdfSByZWY9e3JlZiBhcyBhbnl9IHsuLi5vdGhlcn0gLz47XG59XG5cbmV4cG9ydCBkZWZhdWx0IGZvcndhcmRSZWYoU3RhbmRhcmQpIGFzIHR5cGVvZiBTdGFuZGFyZDtcbiJdfQ== */")),
    ref: ref
  }, other));
}

__signature__(Standard, "useStyles{classes}", function () {
  return [useStyles];
});

var _default = (0, _react.forwardRef)(Standard);

var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useStyles, "useStyles", "/builds/bA1zbJom/0/gojob/ui-bits/src/Input/Standard.tsx");
  reactHotLoader.register(Standard, "Standard", "/builds/bA1zbJom/0/gojob/ui-bits/src/Input/Standard.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Input/Standard.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();